import styled from "styled-components";
import { FiAlertCircle } from "react-icons/fi";

const AutoPayBanner = () => {
  return (
    <AutoPayBannerWrapper>
      <BannerIconWrap>
        <FiAlertCircle />
      </BannerIconWrap>
      <BannerContent>
        <BannerText>
          Auto-Pay is only available for credit card payments.
        </BannerText>
      </BannerContent>
    </AutoPayBannerWrapper>
  );
};

const AutoPayBannerWrapper = styled.div`
  position: relative;
  margin-bottom: 18px;
  padding: 16px 18px;
  border-radius: 14px;
  border: 1px solid rgba(0, 87, 255, 0.22);
  background: #eef4ff;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const BannerIconWrap = styled.div`
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  background: rgba(0, 87, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0057ff;
  font-size: 17px;
`;

const BannerText = styled.div`
  color: #1a2f5a;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;
const BannerContent = styled.div`
  min-width: 0;
`;

export default AutoPayBanner;
